import { http } from 'vue'

export default {
  putContact (context, params = {}) {
    return http.put('contacts/' + params.id, params.data)
  },
  postContact (context, params = {}) {
    return http.post('contacts', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/actions.js